/*  ========================================================================
    # Hooks - Use URL Params
    ========================================================================  */

import { useState, useEffect } from 'react';

/**
 * Returns all URL parameters and a function to update them.
 */
const useUrlParams = (): {
  params: URLSearchParams;
  setUrlParams: (newParams: Record<string, string | number | null>) => void;
} => {
  const [params, setParams] = useState(new URLSearchParams(window.location.search));

  /**
   * Initially remove all empty URL parameters.
   */
  useEffect(() => {
    for (const key of params.keys()) {
      if (params.get(key) === '') params.delete(key);
    }

    // Check if params is empty.
    const paramsString = params.toString();
    const newUrl = paramsString ? `?${paramsString}` : window.location.pathname;

    // Set new URL.
    window.history.replaceState({}, '', newUrl);
  }, []);

  /**
   * Set URL parameters.
   */
  const setUrlParams = (newParams: Record<string, string | number | null>) => {
    Object.entries(newParams).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        params.delete(key);
      } else {
        params.set(key, value as string);
      }
    });

    // Check if params is empty.
    const paramsString = params.toString();
    const newUrl = paramsString ? `?${paramsString}` : window.location.pathname;

    // Set new URL.
    window.history.replaceState({}, '', newUrl);
    setParams(new URLSearchParams(window.location.search));
  };

  return { params, setUrlParams };
};

export default useUrlParams;
